<template>
  <div class="PageInvitation" v-if="invitation">
    <div class="body">
      <p class="heading">{{invitation.child.name}}さんの保護者に<br />招待されています</p>
      <div class="avatar-wrap">
        <ChildAvatar :child="invitation.child" />
      </div>
      <div class="apply"><UiButton :isLoading="isLoading" @click="apply">保護者になる</UiButton></div>
    </div>
  </div>
</template>

<script>
import ChildAvatar from '@/components/atoms/ChildAvatar'
import UiButton from '@/components/atoms/UiButton'

import FirebaseInvitation from '@/firebase/invitations.ts'
const firebaseInvitation = new FirebaseInvitation()

export default {
  name: 'PageInvitation',
  layout: 'app',
  components: {
    ChildAvatar,
    UiButton,
  },
  data() {
    return {
      invitation: null,
      isLoading: false,
    }
  },
  watch: {
    invitationId: {
      handler: 'getInvitations',
      immediate: true,
    },
  },
  props: {
    children: {},
  },
  methods: {
    async getInvitations(invitationId) {
      const invitation = await firebaseInvitation.getInvitation(invitationId)
      const already = this.children.map(o => o.id).includes(invitation.child.id)
      if (already) {
        this.$notify('既に保護者です')
        return this.$router.push(`/children/${invitation.child.id}`)
      }
      this.invitation = invitation
    },
    async apply() {
      this.isLoading = true
      const child = this.invitation.child
      await firebaseInvitation.applyInvitation(this.invitationId, child.id)
      this.$notify(`${child.name}の保護者になりました`)
      this.$router.push(`/children/${child.id}`)
    },
  },
  computed: {
    invitationId() {
      return this.$route.params.invitationId
    },
  },
}
</script>

<style scoped lang="scss">
.PageInvitation {
  background: $secondary;
  min-height: 100vh;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.body {
  color: #fff;
  flex: 1;
}
.heading {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}
.avatar-wrap {
  width: 100px;
  margin: 0 auto 35px;
}
.apply {
  padding: 0 45px;
}
</style>
